var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.level === 0)?_c('div',[_vm._v("Unsatisfactory")]):(_vm.level === 1)?_c('div',[_vm._v("Progressing")]):(_vm.level === 2)?_c('div',[_vm._v("Effective")]):(_vm.level === 3)?_c('div',[_vm._v("Highly Effective")]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }